<ng-container *transloco="let t">
  @if (openedStatus()) {
    <pxw-tag [type]="tagType()" size="xs" (click)="displayWorkingHours($event)">
      {{ tagText() }}
    </pxw-tag>
  }
</ng-container>
